import { motion } from "framer-motion";
import { Star, BadgeCheck, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/constants/site";

const EASE = [0.16, 1, 0.3, 1];

export default function Testimonials() {
  return (
    <section id="temoignages" className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="mb-12 md:mb-16"
        >
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-cyan-300">06 — Témoignages</p>
          <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Ils ont reçu leur <span className="text-holo">pièce unique</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.id}
              initial={{ opacity: 0, y: 34 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.65, ease: EASE, delay: i * 0.12 }}
              data-testid={`testimonial-card-${t.id}`}
              className="relative flex flex-col rounded-2xl border border-white/10 bg-[#100e19] p-7 transition-colors duration-500 hover:border-white/25"
            >
              <Quote size={26} className="mb-4 text-fuchsia-500/40" aria-hidden="true" />
              <div className="mb-4 flex gap-1" aria-label="5 étoiles">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={14} className="fill-amber-300 text-amber-300" />
                ))}
              </div>
              <blockquote className="flex-1 text-sm leading-relaxed text-[#c8c4d8]">« {t.quote} »</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-5">
                <span className="font-display flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-tr from-cyan-500/30 to-fuchsia-500/30 text-sm font-bold text-white">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-white">{t.name}</p>
                  <p className="text-xs text-[#6c6685]">{t.role}</p>
                </div>
                <span className="ml-auto flex items-center gap-1 font-mono text-[9px] uppercase tracking-wider text-emerald-400">
                  <BadgeCheck size={12} /> Vérifié
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <p className="mt-8 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-[#6c6685]">
          Avis d'exemple — à remplacer par vos vrais avis clients
        </p>
      </div>
    </section>
  );
}
